import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgContrastIcon from './svgs/ContrastIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var contrastIcon = (props => useIcon(SvgContrastIcon, SvgContrastIcon, props));

export { contrastIcon as default };
